import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Tag, User, LogOut, Heart } from 'lucide-react';
import AlertsNotification from './AlertsNotification';
import { CILogo } from '../CILogo';

export default function ConsumerNavbar() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is logged in
    const userStr = sessionStorage.getItem('consumer_user');
    if (userStr) {
      try {
        setUser(JSON.parse(userStr));
      } catch (e) {
        console.error('Failed to parse user:', e);
      }
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('consumer_session_token');
    sessionStorage.removeItem('consumer_user');
    setUser(null);
    navigate('/');
  };

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button 
            onClick={() => navigate('/')} 
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <CILogo size="sm" showText={true} variant="color" />
          </button>

          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium flex items-center gap-2"
              data-testid="nav-home"
            >
              <Home className="w-4 h-4" />
              Home
            </button>
            <button
              onClick={() => navigate('/deals')}
              className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium flex items-center gap-2"
              data-testid="nav-deals"
            >
              <Tag className="w-4 h-4" />
              All Deals
            </button>

            {user ? (
              /* Logged In User Menu */
              <>
                <button
                  onClick={() => navigate('/watchlist')}
                  className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium flex items-center gap-2"
                  data-testid="nav-watchlist"
                >
                  <Heart className="w-4 h-4" />
                  Watchlist
                </button>
                <AlertsNotification />
                <div className="flex items-center gap-3 pl-4 border-l border-gray-200">
                  <div className="text-right">
                    <p className="text-sm font-semibold text-gray-900">{user.name}</p>
                    <p className="text-xs text-gray-500">{user.email}</p>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="p-2 text-gray-400 hover:text-red-600 transition-colors"
                    title="Logout"
                  >
                    <LogOut className="w-5 h-5" />
                  </button>
                </div>
              </>
            ) : (
              /* Not Logged In */
              <>
                <button
                  onClick={() => navigate('/auth')}
                  className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium flex items-center gap-2"
                  data-testid="nav-signin"
                >
                  <User className="w-4 h-4" />
                  Sign In
                </button>
                <button
                  onClick={() => navigate('/merchant/login')}
                  className="px-4 py-2 border-2 border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors font-semibold"
                  data-testid="nav-merchant-login"
                >
                  Merchant Login
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
